import {
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
  Box,
} from '@mui/material'
import { entities } from '../../constants/entities'
import useQueryWithLoader from '../../hooks/useQueryWithLoader'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faComputer,
  faQuestionCircle,
  faSheetPlastic,
  faTools,
  faWarehouse,
} from '@fortawesome/free-solid-svg-icons'
import PendingBadge from './PendingBadge'

const APPLICATION_ICONS = {
  ALUGUEL: faComputer,
  ALMOXARIFADO: faWarehouse,
  MANUTENÇÃO: faTools,
  FATURAMENTO: faSheetPlastic,
}

const ApplicationColumn = ({
  app,
  user,
  userRoles,
  UserHasRole,
  baseServiceGet,
  onSelect,
  pendingCount = 0,
}) => {
  const { data: organs } = useQueryWithLoader({
    queryKey: ['organs', user.id, app.id],
    queryFn: async () => {
      const response = await baseServiceGet(
        entities.users.applicationsAndOrganizations(user.id, app.id)
      )
      return response.result.data
    },
    enabled: app.name?.toUpperCase() !== 'FATURAMENTO',
  })

  const appIcon = APPLICATION_ICONS[app.name?.toUpperCase()] || faQuestionCircle

  return (
    <Box sx={{ width: { xs: '100%', md: '450px' }, m: 2, position: 'relative' }}>
      {/* Notificação de pendências na lateral direita do módulo */}
      <PendingBadge count={pendingCount} moduleName={app.name} />

      <Card elevation={4} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        {/* Header no estilo da imagem */}
        <Box
          sx={{
            background: 'linear-gradient(90deg, #0d2142 0%, #3478dd 100%)', // Azul escuro do cabeçalho
            color: 'white',
            textAlign: 'center',
            px: 4,
            py: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
          <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold' }}>
            {app.name}
          </Typography>

          {/* // icone */}
          <FontAwesomeIcon icon={appIcon} size="2xl" />
        </Box>

        <CardContent sx={{ bgcolor: '#f5f5f5', p: 2 }}>
          <Stack spacing={1.5}>
            {organs?.map((organ) => (
              <Button
                key={organ.id}
                variant="contained"
                fullWidth
                onClick={() => onSelect(organ)}
                sx={{
                  background:
                    'linear-gradient(90deg, #0d2142 0%, #3478dd 100%)',
                  '&:hover': {
                    filter: 'brightness(1.2)',
                    transform: 'scale(1.01)',
                  },
                  py: 1.5,
                  fontWeight: 'bold',
                  fontSize: '0.85rem',
                }}>
                {organ.name}
              </Button>
            ))}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  )
}

export default ApplicationColumn
